import React, { useState } from 'react';
import linkdin from '../img/linkdin.png';
import youtube from '../img/youtube2.png';
import whatsapp from '../img/whatsapp2.png';
import linkdinDark from '../img/linkdinDark.png';
import youtubeDark from '../img/youtubeDark.png';
import whatsappDark from '../img/whatsappDark.png';

const Contact = (props) => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');

  // Handle input changes
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [id]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    try {
      const response = await fetch('https://formspree.io/f/xpwzzvjl', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('Message sent successfully!');
        setFormData({ name: '', email: '', message: '' }); // Clear the form
      } else {
        setStatus('Oops! Something went wrong.');
      }
    } catch (error) {
      setStatus('Failed to send message.');
    }
  };

  return (
    <div id={props.contact} className="container mx-auto mt-6 mb-10">
      <div className="flex flex-col gap-5 items-center">
        <h1 className={`font-bold ${props.darkMode?'text-orange-500':'text-purple-800'}`}>Contact</h1>
        <h2 className={`text-3xl font-semibold text-center ${props.darkMode?'text-white':'text-black'}`}>Have a Question?</h2>
        <p className="w-full md:w-2/3 text-center text-gray-400">
          Do You Have an Idea? Let’s Discuss What We Can Do Together
        </p>
      </div>

      {/* Main Section */}
      <div className="relative flex items-center justify-center px-5">
        {/* Centered Blurred Colored Circle */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-[200px] h-[200px] rounded-full blur-3xl"></div>
        </div>

        {/* Glassmorphism Form */}
        <div className="relative backdrop-blur-xl rounded-xl p-6 sm:p-10 w-full max-w-lg">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="name" className={`${props.darkMode?'text-white':'text-black'} block text-sm font-medium mb-2`}>
                Your Name
              </label>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={handleChange}
                required
                className={`w-full px-4 py-2 rounded-lg border placeholder-gray-500 focus:ring-2 outline-none ${props.darkMode?'border-orange-500 focus:ring-orange-700 bg-neutral-950 text-white':' border-purple-800 focus:ring-purple-400 bg-white text-black'}`}
                placeholder="Enter your name"
              />
            </div>

            <div>
              <label htmlFor="email" className={`${props.darkMode?'text-white':'text-black'} block text-sm font-medium mb-2`}>
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                required
                className={`w-full px-4 py-2 rounded-lg border placeholder-gray-500 focus:ring-2 outline-none ${props.darkMode?'border-orange-500 focus:ring-orange-700 bg-neutral-950 text-white':' border-purple-800 focus:ring-purple-400 bg-white text-black'}`}
                placeholder="Enter your email"
              />
            </div>

            <div>
              <label htmlFor="message" className={`${props.darkMode?'text-white':'text-black'} block text-sm font-medium mb-2`}>
                Message
              </label>
              <textarea
                id="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="4"
                className={`w-full px-4 py-2 rounded-lg border placeholder-gray-500 focus:ring-2 outline-none ${props.darkMode?'border-orange-500 focus:ring-orange-700 bg-neutral-950 text-white':' border-purple-800 focus:ring-purple-400 bg-white text-black'}`}
                placeholder="Type your message here..."
              ></textarea>
            </div>

            <button
              type="submit"
              className={`w-full text-white font-bold py-3 rounded-lg transition-transform transform hover:scale-105 ${props.darkMode?'bg-orange-600 hover:bg-orange-700':'bg-purple-600 hover:bg-purple-700'}`}
            >
              Send Message
            </button>
          </form>

          <p className="text-center mt-4 text-gray-600">{status}</p>
        </div>
      </div>

      {/* Social Media Links */}
      <div className={`${props.darkMode?'bg-neutral-900 border border-orange-500':' bg-white border border-purple-800'} fixed right-4 bottom-4 w-16 h-auto rounded-lg p-4 flex flex-col items-center shadow-lg shadow-indigo-500/40`}>
        <div className="flex flex-col gap-4 items-center">
          <a href="https://www.linkedin.com/in/arsalmehmood" target="_blank" rel="noopener noreferrer">
            <img src={props.darkMode?linkdinDark:linkdin} alt="LinkedIn" className="w-8 h-8 transition-transform hover:scale-105" />
          </a>
          <a href="https://www.youtube.com/@blowart4" target="_blank" rel="noopener noreferrer">
            <img src={props.darkMode?youtubeDark:youtube} alt="YouTube" className="w-8 h-8 transition-transform hover:scale-105" />
          </a>
          <a href="https://wa.me/+923092874798" target="_blank" rel="noopener noreferrer">
            <img src={props.darkMode?whatsappDark:whatsapp} alt="Whatsap" className="w-8 h-8 transition-transform hover:scale-105" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
